import { render, staticRenderFns } from "./SubpageCards.vue?vue&type=template&id=a8f3ad4c"
import script from "./SubpageCards.vue?vue&type=script&lang=js"
export * from "./SubpageCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../_themes/ortus-2019/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports